import type { ComponentPropsWithoutRef } from "react"
import { forwardRef, memo } from "react"

import type { IconType } from "@productlane/ui"
import {
	HighPriorityIcon,
	LowPriorityIcon,
	MediumPriorityIcon,
	NoPriorityIcon,
	UrgentPriorityIcon,
} from "@productlane/ui"

const IconMap: Record<string, IconType> = {
	Low: LowPriorityIcon,
	Medium: MediumPriorityIcon,
	High: HighPriorityIcon,
	"No priority": NoPriorityIcon,
	Urgent: UrgentPriorityIcon,
}

export const issuePriorityIcon = (priority: string): IconType =>
	IconMap[priority] ?? NoPriorityIcon

interface IssuePriorityIconProps extends ComponentPropsWithoutRef<"svg"> {
	priority: string
}

export const IssuePriorityIcon = memo(
	forwardRef<SVGSVGElement, IssuePriorityIconProps>(
		({ priority, ...props }, ref) => {
			const Icon = issuePriorityIcon(priority)
			return <Icon ref={ref} {...props} />
		},
	),
)
